import {
  Box,
  Button,
  FormLabel,
  Modal,
  Stack,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { StyledInput } from "../ui/StyledInput";
import toast from "react-hot-toast";
import { addOrderTagMethod } from "../features/orders/orderApi";
import { StyledButton } from "../ui/StyledButton";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  p: 4,
  minHeight: "400px",
  borderRadius: "6px",
};

const OrderTagModal = ({
  open,
  handleClose,
  id,
}: {
  open: boolean;
  handleClose: () => void;
  id: string | number;
}) => {
  const [tags, setTags] = useState<string>("");
  const [totalTags, setTotalTags] = useState<number>(0);
  const [canSubmit, setCanSubmit] = useState<boolean>(false);

  const onEnterInsertTag = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (tags) {
      if (tags[tags.length - 1] !== ",") {
        setTags(`${tags + ","}`);
      }
    }
  };

  const onInputChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setTags(event.target.value);
  };

  useEffect(() => {
    setTotalTags(tags.split(",").length - 1);
    if (tags) {
      setCanSubmit(true);
    } else {
      setCanSubmit(false);
    }
  }, [tags]);

  const addOrderTagHandler = () => {
    addOrderTagMethod({
      id: id,
      tag: tags,
    })
      .then((data) => {
        toast.success("Order tagged successfully!");
        handleClose();
        setTags("");
      })
      .catch((err) => console.log(err));
  };

  return (
    <Modal
      open={open}
      sx={{
        backgroundColor: "#ffffffc",
      }}
      onClose={handleClose}
    >
      <Box sx={style}>
        <Stack
          justifyContent={"space-between"}
          direction={"column"}
          sx={{
            minHeight: "340px",
          }}
        >
          <div>
            <Typography variant="h6" component="h2" marginBottom={"20px"}>
              Add Order Tag
            </Typography>
            <form onSubmit={onEnterInsertTag}>
              <FormLabel>
                <Typography fontSize={12}>Add Tags</Typography>
              </FormLabel>
              <StyledInput
                value={tags}
                onChange={onInputChange}
                placeholder="Add new tag and press enter"
                fullWidth
              />
            </form>
          </div>

          <div>
            <div
              style={{
                marginBottom: "20px",
              }}
            >
              <Typography>{`${totalTags} Tag added`}</Typography>
            </div>
            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}
              gap={"8px"}
            >
              <StyledButton onClick={handleClose} variant="outlined">
                Cancel
              </StyledButton>
              <StyledButton
                disabled={!canSubmit}
                onClick={addOrderTagHandler}
                variant="contained"
              >
                Save
              </StyledButton>
            </Stack>
          </div>
        </Stack>
      </Box>
    </Modal>
  );
};

export default OrderTagModal;
